!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.library = t() : e.library = t();
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }
    var r = {};
    return t.m = e, t.c = r, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "/dist/", t(t.s = 1);
  }([function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = function (e) {
        return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      },
      o = function (e, t) {
        return (e.match(t) || []).length;
      },
      a = function (e, t, r) {
        return e.toLocaleString(t, {
          minimumFractionDigits: r,
          maximumFractionDigits: r
        });
      },
      i = function (e, t) {
        return t[e];
      },
      u = function (e, t, r, n) {
        for (var o = "", a = e || "", u = 0; u < a.length; u += 1) {
          var c = a.charAt(u),
            f = t.charAt(u),
            l = i(f, n);
          l && (l.regExp.test(c) ? o = o.concat(c) : c === r && (a = ""));
        }
        return o;
      },
      c = function (e, t, r, n, o, a) {
        var u = "",
          c = e || "";
        if (0 === c.length && o && !n) return "";
        for (var f = 0, l = 0; l < t.length; l += 1) {
          var s = c.charAt(f),
            p = t.charAt(l),
            h = i(p, a);
          if (h) {
            if (s) {
              if (h.regExp.test(s)) u = u.concat(s), f += 1;else {
                if (!n) return u;
                u = u.concat(r), c = "";
              }
            } else {
              if (!n) return u;
              u = u.concat(r);
            }
          } else u = u.concat(p);
        }
        return u;
      },
      f = function (e, t, r, o, a, u) {
        for (var f = e || "", l = 0; l < t.length; l += 1) {
          var s = t.charAt(l);
          if (!i(s, u)) {
            var p = n(s);
            f = f.replace(new RegExp(p), "");
          }
        }
        var h = n(r);
        return f = f.replace(h, ""), c(f, t, r, o, a, u);
      },
      l = function (e, t, r) {
        if (!e || 0 === e.length) return !1;
        if (e.length !== t.length) return !1;
        for (var n = 0; n < e.length; n += 1) {
          var o = e.charAt(n),
            a = t.charAt(n),
            u = i(a, r);
          if (u) {
            if (!u.regExp.test(o)) return !1;
          } else if (o !== a) return !1;
        }
        return !0;
      },
      s = function (e, t) {
        var r = [];
        if (!e || "string" != typeof e || 0 === e.length) return r;
        i(e.charAt(0), t) && r.push(0);
        for (var n = 1; n < e.length; n += 1) {
          var o = e.charAt(n - 1),
            a = e.charAt(n);
          (i(o, t) || i(a, t)) && r.push(n);
        }
        return i(e.charAt(e.length - 1), t) && r.push(e.length), r;
      },
      p = function (e, t, r, n) {
        if ("" === e) return 0;
        for (var o = 0; o < e.length; o += 1) {
          var a = e.charAt(o),
            u = t.charAt(o);
          if (a === r && a !== u) return o;
        }
        if (e.length === t.length) for (var c = t.length - 1; c >= 0; c -= 1) {
          var f = t.charAt(c);
          if (i(f, n)) return c + 1;
        }
        return e.length;
      },
      h = function (e, t, r, n) {
        for (var o = e || "", a = t || "", u = "", c = 0; c < o.length; c += 1) {
          var f = o.charAt(c);
          if (f !== a.charAt(c)) {
            var l = r.charAt(c),
              s = i(l, n);
            u = s && s.transform ? u.concat(s.transform(f)) : u.concat(f);
          } else u = u.concat(f);
        }
        return u;
      },
      v = function (e, t) {
        for (var r = Object.keys(t), n = 0; n < r.length; n += 1) {
          var o = r[n];
          if (t[o].regExp.test(e)) return o;
        }
      };
    t.applyMask = c, t.applyTransform = h, t.countOcurrences = o, t.escapeRegExp = n, t.firstUnfilledPosition = p, t.getMaskDefinition = i, t.inputReformat = f, t.isPatternComplete = l, t.maskStrip = u, t.numberToLocaleString = a, t.charMatchTest = v, t.validCaretPositions = s;
  }, function (e, t, r) {
    e.exports = r(2);
  }, function (e, t, r) {
    "use strict";

    function n(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.createTextMask = t.createNumberMask = void 0;
    var o = r(3),
      a = n(o),
      i = r(4),
      u = n(i);
    t.createNumberMask = a.default, t.createTextMask = u.default;
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(0);
    t.default = function (e) {
      var t = e || {},
        r = t.prefix,
        o = void 0 === r ? "" : r,
        a = t.suffix,
        i = void 0 === a ? "" : a,
        u = t.decimalPlaces,
        c = void 0 === u ? 0 : u,
        f = t.multiplier,
        l = void 0 === f ? 1 : f,
        s = t.stringValue,
        p = void 0 !== s && s,
        h = t.allowEmpty,
        v = void 0 !== h && h,
        g = t.allowNegative,
        d = void 0 !== g && g,
        m = t.showPlusSign,
        b = void 0 !== m && m,
        x = t.spaceAfterSign,
        y = void 0 !== x && x,
        k = t.locale,
        w = t.onChange;
      if (c > 10) throw new Error("The maximum value for createNumberMask's option `decimalPlaces` is 10.");
      if ("number" != typeof l) throw new Error("The createNumberMask's option `multilpier` should be of type number.");
      if (0 === l) throw new Error("The createNumberMask's option `multilpier` cannot be zero.");
      var M = function (e) {
          var t = e;
          if (void 0 === t || "" === t) {
            if (v) return "";
            t = 0;
          } else "number" != typeof t && (t = Number(t));
          var r = b ? "+" : "";
          return t < 0 && (t *= -1, d && (r = "-")), r && y && (r += " "), t *= 1 / l, t = (0, n.numberToLocaleString)(t, k, c), "" + r + o + t + i;
        },
        A = function (e, t) {
          var r = (0, n.escapeRegExp)(o),
            a = (0, n.escapeRegExp)(i),
            u = new RegExp("^[-|+]? ?" + r),
            f = new RegExp(a + "$"),
            s = 1;
          if (d) {
            var h = /-/g,
              g = (0, n.countOcurrences)(e, h) - (0, n.countOcurrences)(o, h) - (0, n.countOcurrences)(i, h);
            s = Math.pow(-1, g) % 2;
          }
          var m = e;
          if (o && (m = m.replace(u, "")), i && (m = m.replace(f, "")), m = m.replace(/\D/g, ""), v) {
            var b = "" === m,
              x = "" === m.replace(/0+/g, ""),
              y = m.length <= c,
              k = void 0 === t;
            if (b || !k && y && x) return "";
          }
          var M = Number(m) / Math.pow(10, c) * s;
          M = Number((M * l).toPrecision(10)), p && (M = M.toString());
          var A = M !== t;
          return w && A && w(M), M;
        },
        E = function (e) {
          var t = e.target;
          t && (e.persist && e.persist(), setTimeout(function () {
            var r = t.value.length - i.length;
            e.target.setSelectionRange(r, r);
          }));
        };
      return {
        format: function (e) {
          return M(e);
        },
        normalize: function (e, t) {
          return A(e, t);
        },
        onChange: function (e) {
          return E(e);
        },
        onFocus: function (e) {
          return E(e);
        },
        autoComplete: "off"
      };
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = r(0),
      o = r(5),
      a = function (e) {
        return e && e.__esModule ? e : {
          default: e
        };
      }(o);
    t.default = function (e) {
      var t = e.pattern,
        r = e.placeholder,
        o = void 0 === r ? "_" : r,
        i = e.maskDefinitions,
        u = void 0 === i ? a.default : i,
        c = e.guide,
        f = void 0 === c || c,
        l = e.stripMask,
        s = void 0 === l || l,
        p = e.allowEmpty,
        h = void 0 !== p && p,
        v = e.onChange,
        g = e.onCompletePattern;
      if (!t) throw new Error("The key `pattern` is required for createTextMask. You probably forgot to add it to your options.");
      if (!o || 1 !== o.length) throw new Error("The key `placeholder` should have a single character as a value.");
      var d = (0, n.validCaretPositions)(t, u);
      if (0 === d.length) throw new Error("The pattern `" + t + "` passed for createTextMask is not valid.");
      var m = (0, n.charMatchTest)(o, u);
      if (m) throw new Error("The placeholder `" + o + "` matches the mask definition`" + m + "`. The mask created using `createTextMask`is therefore invalid.");
      var b = (0, n.maskStrip)(t, t, o, u),
        x = function (e) {
          var r = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
          return e ? s || r ? (0, n.applyMask)(e, t, o, f, h, u) : e : (0, n.applyMask)("", t, o, f, h, u);
        },
        y = function (e, r) {
          var a = (0, n.inputReformat)(e, t, o, f, h, u),
            i = (0, n.maskStrip)(a, t, o, u),
            c = (0, n.applyTransform)(i, s ? r : (0, n.maskStrip)(r, t, o, u), b, u),
            l = x(c, !0),
            p = s ? c : l,
            d = p !== r && ("" !== p || void 0 !== r);
          return v && d && v(p), g && (0, n.isPatternComplete)(l, t, u) && d && setTimeout(function () {
            return g(p);
          }, 10), p;
        },
        k = function (e) {
          var r = (0, n.firstUnfilledPosition)(e.value, t, o, u);
          e.setSelectionRange(r, r);
        },
        w = function (e, t, r) {
          for (var n = void 0, o = 0; o <= d.length; o += 1) {
            if (d[o] > t) {
              n = o;
              break;
            }
          }
          var a = void 0;
          if (void 0 === (a = "left" === r ? d[n - 1] : d[n])) {
            var i = "left" === r ? 0 : d.length - 1;
            a = d[i];
          }
          e.setSelectionRange(a, a);
        },
        M = function (e) {
          if (e.target) {
            e.persist && e.persist();
            var r = e.target.selectionStart,
              n = e.target.value;
            setTimeout(function () {
              var o = e.target,
                a = e.type,
                i = e.key,
                u = e.target,
                c = u.value,
                f = u.selectionStart,
                l = u.selectionEnd;
              switch (a) {
                case "change":
                  if (c.length === n.length + 1 && c.charAt(r) === t.charAt(r)) {
                    w(o, r, "left");
                    break;
                  }
                  k(o);
                  break;
                case "focus":
                  k(o);
                  break;
                case "click":
                  f === l && (d.indexOf(f) >= 0 ? e.preventDefault() : k(o));
                  break;
                case "keydown":
                  "ArrowLeft" === i ? w(o, f, "left") : "ArrowRight" === i && w(o, r, "right");
              }
            });
          }
        };
      return {
        format: function (e) {
          return x(e);
        },
        normalize: function (e, t) {
          return y(e, t);
        },
        onKeyDown: function (e) {
          return M(e);
        },
        onChange: function (e) {
          return M(e);
        },
        onFocus: function (e) {
          return M(e);
        },
        onClick: function (e) {
          return M(e);
        },
        autoComplete: "off"
      };
    };
  }, function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = {
      A: {
        regExp: /[A-Za-z]/,
        transform: function (e) {
          return e.toUpperCase();
        }
      },
      a: {
        regExp: /[A-Za-z]/,
        transform: function (e) {
          return e.toLowerCase();
        }
      },
      U: {
        regExp: /[A-Z]/
      },
      l: {
        regExp: /[a-z]/
      },
      9: {
        regExp: /[0-9]/
      }
    };
  }]);
});